var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"mt-3",attrs:{"no-body":"","type":"dark","bg-variant":"light"}},[_c('b-col',{staticClass:"ml--2"},[_c('h3',{staticClass:"mt-1 ml-1"},[_vm._v("Rezeptmanagment")])])],1),_c('StempelCard'),_c('InputCardConnect',{attrs:{"connect":_vm.useConnect,"input":{
      headline: 'Connect Hinweg',
      vuexModule: 'Rezeptmanagment',

      row1: {
        text: 'AT',
        icon: 'clock-history',

        value: 'Rezeptmanagment/connectHinwegAt'
      },
      row2: {
        text: 'Stunden pro Tag',
        icon: 'clock',
        value: 'Rezeptmanagment/connectHinwegStundenProTag'
      },
      row3: {
        text: 'Stunden pro Monat',
        disabledCheck: true,
        icon: 'clock',
        value: 'Rezeptmanagment/connectHinwegStundenMonat',
        mutationName: ''
      },
      row4: {
        text: 'Belege pro Stunde',
        icon: 'files',
        value: 'Rezeptmanagment/connectHinwegBelegeProStunde',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Monat',
        icon: 'cash-stack',
        value: 'Rezeptmanagment/connectHinwegKostenProMonat'
      },
      row6: {
        text: 'Kosten pro Beleg',
        icon: 'cash',
        value: 'Rezeptmanagment/connectHinwegKostenProBeleg'
      }
    }}}),_c('InputCardConnect',{attrs:{"connect":_vm.connectMitExport,"input":{
      headline: 'Connect inkl. Rückweg',
      vuexModule: 'Rezeptmanagment',

      row1: {
        text: 'AT',
        icon: 'clock-history',
        value: 'Rezeptmanagment/connectRueckwegAt'
      },
      row2: {
        text: 'Stunden pro Tag',
        icon: 'clock',
        value: 'Rezeptmanagment/connectRueckwegStundenProTag'
      },
      row3: {
        text: 'Stunden pro Monat',
        disabledCheck: true,
        icon: 'clock',
        value: 'Rezeptmanagment/connectRueckwegStundenMonat',
        mutationName: ''
      },
      row4: {
        text: 'Belege pro Stunde',
        icon: 'files',
        value: 'Rezeptmanagment/connectRueckwegBelegeProStunde',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Monat',
        icon: 'cash-stack',
        value: 'Rezeptmanagment/connectRueckwegKostenProMonat'
      },
      row6: {
        text: 'Kosten pro Beleg',
        icon: 'cash',
        value: 'Rezeptmanagment/connectRueckwegKostenProBeleg'
      }
    }}}),_c('InputCardConnect',{attrs:{"connect":_vm.connectOhneExport,"input":{
      headline: 'Connect Rückweg exkl. Datenexport',
      vuexModule: 'Rezeptmanagment',

      row1: {
        text: 'AT',
        icon: 'clock-history',
        value: 'Rezeptmanagment/connectRueckwegOhneDatenexportAt'
      },
      row2: {
        text: 'Stunden pro Tag',
        icon: 'clock',
        value: 'Rezeptmanagment/connectRueckwegOhneDatenexportStundenProTag'
      },
      row3: {
        text: 'Stunden pro Monat',
        disabledCheck: true,
        icon: 'clock',
        value: 'Rezeptmanagment/connectRueckwegOhneDatenexportStundenMonat',
        mutationName: ''
      },
      row4: {
        text: 'Belege pro Stunde',
        icon: 'files',
        value:
          'Rezeptmanagment/connectRueckwegOhneDatenexportBelegeProStunde',
        mutationName: ''
      },
      row5: {
        text: 'Kosten pro Monat',
        icon: 'cash-stack',
        value: 'Rezeptmanagment/connectRueckwegOhneDatenexportKostenProMonat'
      },
      row6: {
        text: 'Kosten pro Beleg',
        icon: 'cash',
        value: 'Rezeptmanagment/connectRueckwegOhneDatenexportKostenProBeleg'
      }
    }}}),_c('div',{staticClass:"mt-3"},[_vm._v(" Im Ergebnis wird zur Zeit Connect nicht berücksichtigt! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }